/**
 * RyzePainter — Single Responsibility: dibujar el modelo 2D de Ryze.
 * Contrato: paint(ctx, pos, radius, entity) → void
 */
export const RyzePainter = {
  paint(ctx, pos, radius, _entity) {
    // Rune Mage Back Scroll
    ctx.beginPath();
    ctx.rect(-radius * 1.1, -radius * 0.4, radius * 0.4, radius * 0.8);
    ctx.fillStyle = '#78350f';
    ctx.fill();

    // Arcane Aura Ring
    ctx.beginPath();
    ctx.arc(0, 0, radius * 1.1, 0, Math.PI * 2);
    ctx.strokeStyle = 'rgba(168, 85, 247, 0.6)';
    ctx.lineWidth = 2;
    ctx.stroke();
  }
};
